var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-controls"},[_c('button',{key:"1",staticClass:"_deny",attrs:{"disabled":!_vm.selectedAccounts.length},on:{"click":function($event){return _vm.toggleConfirmReject()}}},[_vm._v("\n        Reject\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }